// Note:This function takes input as string of hours minutes separated by colons  and converts it to minutes

const convertHoursToMinutes = (timeInHour: any) => {
    var timeParts = timeInHour.split(":");
    return Number(timeParts[0]) * 60 + Number(timeParts[1]);
  };
export default convertHoursToMinutes;